// This file is auto-generated. Do not edit manually.
export const VERSION = {
  date: "2026-04-12T23:18:20.520Z",
  commit: "c96a49f0460afbf7b600c5e7acf82d0d38c78826",
} as const;

export type Version = typeof VERSION;
